export const DEFAULT_VALUE = 1;
export const VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
//# sourceMappingURL=number-of-rows.js.map